// src/Loading.js
import React, { useState, useEffect } from 'react'; // Dodaj useState i useEffect
import { NavLink } from 'react-router-dom';
import IonIcon from '@reacticons/ionicons';
import './Loading.css'; // Dodaj import CSS


const Loading = ({ isSmall }) => {

  const icons = ["hammer-outline", "construct-outline", "storefront-outline"]; // Updated icons for repair context
  const texts = [
 "Trwa ładowanie...",
 "Naprawa pralek w Krakowie", // Tekst do wyświetlenia
  "Profesjonalna pomoc w naprawie pralek",
  "Zadzwoń teraz!", // Tekst do wyświetlenia
 "Przemysław Sikora - Serwis AGD",
  "Dojazd na terenie Krakowa - GRATIS",
  "Szybki termin realizacji",
  "Gwarancja na wykonane usługi",
  "Wieloletnie doświadczenie",
  "Diagnoza - tylko 100 zł",
  "Naprawa pralek - Kraków",
  "Pralka nie działa?",
  "Nie czekaj, zadzwoń teraz!",
  "Naprawa pralek - szybka pomoc",
  "Pralka nie grzeje wody?",
  "Pralka nie odpompowuje wody?",
  "Naprawa pralek w Krakowie",
  "Pralka nie wiruje?",
  "Naprawa pralek - profesjonalna pomoc",
  "Pralka nie otwiera drzwi?",
  "Naprawa pralek - szybka diagnoza",
  "Pralka nie nabiera wody?",
  "Naprawa pralek - skuteczne rozwiązania",
  "Pralka nie działa? Zadzwoń teraz!",
  "Naprawa pralek - szybka pomoc w Krakowie",
  "Pralka nie grzeje? Zadzwoń teraz!",
  ]; // Zbiór tekstów
  const [iconIndex, setIconIndex] = useState(0); // Indeks ikony
  const [displayedText, setDisplayedText] = useState(""); // Tekst do wyświetlenia
 

  useEffect(() => {
    const interval = setInterval(() => {
      setIconIndex(prevIndex => (prevIndex + 1) % icons.length); // Przełączanie ikon i tekstów
    }, 4000); // Zmiana co 4 sekundy

    return () => clearInterval(interval); // Czyszczenie interwału
  }, []);

  useEffect(() => {
    let currentText = "";
    let charIndex = 0;

    const typingInterval = setInterval(() => {
      if (charIndex < texts[iconIndex].length) {
        currentText += texts[iconIndex][charIndex];
        setDisplayedText(currentText);
        charIndex++;
      } else {
        clearInterval(typingInterval);
      }
    }, 100); // Czas między literami

    return () => clearInterval(typingInterval); // Czyszczenie interwału
  }, [iconIndex]);

  return (
    <div className={isSmall ? "loading-container-small" : "loading-container"}>
      <div className="loading-icon">
        <IonIcon name={icons[iconIndex]} size={50} className="spin" />
      </div>
      <h2>{displayedText}</h2>
    </div>
  );
};

export default Loading;